/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccE2eFixtureResetResponse } from './PccE2eFixtureResetResponse';
import {
    PccE2eFixtureResetResponseFromJSON,
    PccE2eFixtureResetResponseFromJSONTyped,
    PccE2eFixtureResetResponseToJSON,
} from './PccE2eFixtureResetResponse';

/**
 *
 * @export
 * @interface ResetPccE2eFixture200Response
 */
export interface ResetPccE2eFixture200Response {
    /**
     *
     * @type {PccE2eFixtureResetResponse}
     * @memberof ResetPccE2eFixture200Response
     */
    data?: PccE2eFixtureResetResponse;
}

/**
 * Check if a given object implements the ResetPccE2eFixture200Response interface.
 */
export function instanceOfResetPccE2eFixture200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResetPccE2eFixture200ResponseFromJSON(json: any): ResetPccE2eFixture200Response {
    return ResetPccE2eFixture200ResponseFromJSONTyped(json, false);
}

export function ResetPccE2eFixture200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPccE2eFixture200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': !exists(json, 'data') ? undefined : PccE2eFixtureResetResponseFromJSON(json['data']),
    };
}

export function ResetPccE2eFixture200ResponseToJSON(value?: ResetPccE2eFixture200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': PccE2eFixtureResetResponseToJSON(value.data),
    };
}
